import React from 'react';
import { IAgentsAvatarCell } from './interfaces';
import { AvatarGroup, Box } from '@mui/material';
import { AgentAvatar } from '../../AgentAvatar';
import { Agent } from '../../AgentAvatar/interfaces';

export const AgentsAvatarCell: React.FC<IAgentsAvatarCell> = ({
  agents,
  alignItems = 'center',
}): JSX.Element => {
  return (
    <Box sx={{ display: 'flex', alignItems, height: '100%' }}>
      {!agents.length && '-'}

      {agents && (
        <AvatarGroup
          sx={{
            '& .MuiAvatarGroup-avatar': {
              width: '25px',
              height: '25px',
              fontSize: '0.75rem',
              border: '2px solid #FFF',
              bgcolor: (theme) => theme.palette.primary.main,
            },
          }}
        >
          {agents.map((agent: Agent, index: number) => (
            <AgentAvatar key={index} agent={agent} variant="pill" />
          ))}
        </AvatarGroup>
      )}
    </Box>
  );
};
